export interface JourneyPerformanceContext {
  lcp_ms?: number;
  inp_ms?: number;
  cls?: number;
  long_task_count?: number;
  slow_api_count?: number;
  slow_resource_count?: number;
  route?: string;
}

const asNumber = (value: unknown): number | undefined => {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
};

export const getJourneyPerformanceContext = (): JourneyPerformanceContext => {
  if (typeof window === 'undefined' || typeof performance === 'undefined') {
    return {};
  }

  try {
    const route = window.location?.pathname || undefined;
    const lcpEntries = performance.getEntriesByType('largest-contentful-paint') as PerformanceEntry[];
    const lcp = lcpEntries.length > 0 ? lcpEntries[lcpEntries.length - 1].startTime : undefined;

    const eventEntries = performance.getEntriesByType('event') as PerformanceEntry[];
    const inp = eventEntries.reduce<number | undefined>((max, entry: any) => {
      const duration = asNumber(entry.duration);
      if (duration === undefined) return max;
      return max === undefined ? duration : Math.max(max, duration);
    }, undefined);

    const layoutShiftEntries = performance.getEntriesByType('layout-shift') as PerformanceEntry[];
    const cls = layoutShiftEntries.reduce((sum, entry: any) => {
      if (entry?.hadRecentInput) return sum;
      return sum + (asNumber(entry?.value) || 0);
    }, 0);

    const longTaskEntries = performance.getEntriesByType('longtask') as PerformanceEntry[];
    const resourceEntries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];

    const slowApiCount = resourceEntries.filter((entry) => {
      const initiator = entry.initiatorType;
      return (initiator === 'fetch' || initiator === 'xmlhttprequest') && entry.duration > 1000;
    }).length;

    const slowResourceCount = resourceEntries.filter((entry) => entry.duration > 2000).length;

    return {
      route,
      lcp_ms: asNumber(lcp),
      inp_ms: asNumber(inp),
      cls: cls > 0 ? Number(cls.toFixed(3)) : undefined,
      long_task_count: longTaskEntries.length || undefined,
      slow_api_count: slowApiCount || undefined,
      slow_resource_count: slowResourceCount || undefined,
    };
  } catch {
    return {};
  }
};
